import classNames from 'classnames'
import React from 'react'
import './index.less'

export default function Ul(props) {
  const { className, style, data = [], value, onChange, onMouseEnter, ulProps, ...otherProps } = props
  return <ul className={classNames('mn-ul', className)} style={style} {...ulProps}>
    {props.children || data.map(item => <Li
      key={item.value}
      active={value === item.value}
      disabled={item.disabled}
      onClick={() => onChange && onChange(item.value, item)}
      onMouseEnter={e => onMouseEnter && onMouseEnter(item.value, e)}
      {...otherProps}
    >{item.label}</Li>)}
  </ul>
}
export const Li = (props) => {
  const { className, style, active, disabled, onClick, readOnly, onMouseEnter, ...otherProps } = props

  return <li
    className={classNames('mn-li', className, { active, disabled })}
    style={style}
    onClick={(e) => {
      if (readOnly || disabled) return
      onClick && onClick(e)
    }}
    onMouseEnter={(e) => {
      if (disabled) return
      onMouseEnter && onMouseEnter(e)
    }}
    {...otherProps}
  >{props.children}</li>
}
